<div *ngIf="!loadingFavorite || !loadingMy || !loadingShared; else dataLoading">
  <div
    *ngIf="favoriteRealProperties?.length > 0 || myRealProperties?.length > 0 || sharedRealProperties?.length > 0; else noData"
    class="wrap-sections">
    <section *ngIf="favoriteRealProperties?.length > 0" class="section-card-list">
      <header>
        <h1>Mes Favoris</h1>
      </header>
      <div class="content">
        <div *ngFor="let prop of favoriteRealProperties" class="item-list">
          <app-property-card [prop]="prop" [showOwnerName]="prop.owner.uid!==currentUserUid" [showFavorite]="true"
            [isFavorite]="true" (favoriteToogled)="loadData()"></app-property-card>
        </div>
      </div>
      <div *ngIf="hasMoreFavorite" class="more">
        <button type="button" mat-flat-button color="primary" class="m-2" (click)="loadFavorite(true)"
          [disabled]="loadingMoreFavorite">
          <ng-container *ngIf="loadingMoreFavorite; else text">
            <mat-icon>
              <mat-spinner diameter="20">
              </mat-spinner>
            </mat-icon>
          </ng-container><ng-template #text>Voir les {{ countMoreFavorite }} biens suivant</ng-template>
        </button>
      </div>
    </section>
    <section *ngIf="myRealProperties?.length > 0 || (canAddProperty && !isFavoriteOwned)" class="section-card-list">
      <header>
        <h1>Mes propriétés</h1>
      </header>
      <div *ngIf="myRealProperties?.length > 0; else noData" class="content">
        <div *ngFor="let prop of myRealProperties" class="item-list">
          <app-property-card [prop]="prop" [showFavorite]="true" (favoriteToogled)="loadData()"></app-property-card>
        </div>
      </div>
      <div *ngIf="hasMoreMy" class="more">
        <button type="button" mat-flat-button color="primary" class="m-2" (click)="loadMy(true)"
          [disabled]="loadingMoreMy">
          <ng-container *ngIf="loadingMoreMy; else text">
            <mat-icon>
              <mat-spinner diameter="20">
              </mat-spinner>
            </mat-icon>
          </ng-container>
          <ng-template #text>Voir les {{ countMoreMy }} biens suivant</ng-template>
        </button>
      </div>
    </section>
    <section *ngIf="sharedRealProperties?.length > 0" class="section-card-list">
      <header>
        <h1>Propriétés partagées</h1>
      </header>
      <div class="content">
        <div *ngFor="let prop of sharedRealProperties" class="item-list">
          <app-property-card [prop]="prop" [showOwnerName]="true" [showFavorite]="true"
            (favoriteToogled)="loadData()"></app-property-card>
        </div>
      </div>
      <div *ngIf="hasMoreShared" class="more">
        <button type="button" mat-flat-button color="primary" class="m-2" (click)="loadShared(true)"
          [disabled]="loadingMoreShared">
          <ng-container *ngIf="loadingMoreShared; else text">
            <mat-icon>
              <mat-spinner diameter="20">
              </mat-spinner>
            </mat-icon>
          </ng-container><ng-template #text>Voir les {{ countMoreShared }} biens suivant</ng-template>
        </button>
      </div>
    </section>
  </div>
</div>


<ng-template #dataLoading>
  <app-data-loading></app-data-loading>
</ng-template>

<ng-template #noData>
  <ng-container *ngIf="canAddProperty; else cantAdd">
    <div class="no-data">
      <app-rounded-link color="primary" (clickEvent)="add()" [icon]="'add_circle_outline'" squareMode="true"
        [text]="'Créez un bien'" [disabled]="userReachedPropertyLimit"></app-rounded-link>
      <div class="text">
        <div>Créez un bien simplement à partir de son adresse</div>
        <div>et découvrez l'expérience EEMO 🚀</div>
      </div>
    </div>
  </ng-container>

  <ng-template #cantAdd>
    <span class="no-content">Aucun bien ne vous a encore été partagé.</span>
  </ng-template></ng-template>